import { render, staticRenderFns } from "./upload-file-dialog.vue?vue&type=template&id=2823a1ad&"
import script from "./upload-file-dialog.vue?vue&type=script&lang=js&"
export * from "./upload-file-dialog.vue?vue&type=script&lang=js&"
import style0 from "./upload-file-dialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports